import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';

import personCircle from './images/person-circle.svg';
import arrowRight from './images/arrow-right.svg';

import Constants from '../../constants/Constants';
import Messages from '../../constants/Messages';
import AppRoutes from '../../constants/AppRoutes';

import AuthenticationService from '../../services/authentication-service';
import { useAuth } from '../../hooks/useAuth';
import DateUtils from '../../utilities/date-utils';
import { ThreeDots } from  'react-loader-spinner';

const ProfileCard = (props) => {

    const {
        isProfilePage = false,
        isEventTime = false,
        showCDWCashBalance = true,
        isLoading = false
    } = props;

    const navigate = useNavigate();
    const [user, setUser] = useState();
    const { authLogout } = useAuth();
    const [currentBalance, setCurrentBalance] = useState({});


     /** ---------------------------------------------------
     * function : get Wallet Balance
     * Description : retrun exact wallet balance based on event time and non-event time
     */
    function getWalletBalance(userDetails, balance) {
       return  props?.userCurrentLocation ? 
                (props?.userCurrentLocation === userDetails?.locationDetails?.name ? 
                    ((balance && balance?.event && balance?.event.amount !== undefined ) ? 
                    (balance?.cdw.amount + balance?.event.amount) : (balance?.cdw.amount ? 
                        balance?.cdw.amount : 0)) : balance?.event.amount) : balance?.cdw?.amount;
    }

    useEffect(() => {
        (async () => {
            const userDetails = await AuthenticationService.getUserDetails();
            let balance = await AuthenticationService.getUserBalance();
            if(typeof balance === Constants.TYPE.NUMBER || userDetails.userRole === Constants.USER_ROLES.VENDOR) {
                balance = {
                    cdw: {
                        name: Constants.TYPE.CDW,
                        amount: balance
                    }
                }
            }
            setCurrentBalance(balance);
            setUser({
                ...userDetails,
                walletBalance: getWalletBalance(userDetails, balance),
                balance: balance
            });
        })();
    }, [props?.balanceValue, props?.userCurrentLocation]);

    /** ---------------------------------------------------
     * Method : resetPassword
     * Description : To navigate user to reset password page
     */
    const resetPassword = async () => {
        navigate(AppRoutes.RESET_PASSWORD);
    }

    /** ---------------------------------------------------
     * Method : logout
     * Description : To logout user from the app
     */
    const logout = async () => {
        authLogout();
        navigate(AppRoutes.LOGIN);
    }

    /** ---------------------------------------------------
     * Method : ellipticise
     * Description : To shorten the lengthy text
     */
    function elliptiscise(name) {
        if(name.length > Constants.CART.ELLIPSIS.LIMIT) name = name.slice(0, Constants.CART.ELLIPSIS.LIMIT) + Constants.CART.ELLIPSIS.CONTENT;
        return name;
    }

    /** ---------------------------------------------------
     * Method : calcBalance
     * Description : Returns balance or loader if loading
     */
    function calcBalance() {
        return (isLoading ? <ThreeDots 
                                height="30" 
                                width="30" 
                                radius="5"
                                color={ Constants.COLORS.WHITE }
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{}}
                                wrapperClassName=''
                                visible={true}
                            /> : user.walletBalance);
    }

    return (
        <>
            {
                user && user.userRole ? (
                    <div className="sticky bg-rose-700 text-white top-[65px] z-10 rounded m-4 mt-0 overflow-hidden shadow-lg">
                        <div className='p-4 flex justify-content flex-nowrap'>
                            {!isEventTime ? (<><div className='basis-1/3'>
                                {user.userRole === Constants.USER_ROLES.EMPLOYEE && user.walletBalance >= 0 ? (
                                    <>
                                        <div className='text-sm'>{Messages.PROFILE.WALLET_BALANCE}</div>
                                        <div className='font-bold text-lg flex flex-row'>
                                            <div className='mr-1'>{Messages.CURRENCY.INR} </div>
                                            { calcBalance() }
                                        </div>
                                    </>
                                ) : null}
                            </div><div className='basis-2/3 flex justify-end items-center'>
                                    <div className='text-right capitalize'>
                                        <div className='font-bold leading-4'>{user.name}</div>
                                        <div className='text-sm'>{user.locationDetails.name}</div>
                                    </div>
                                    {!isProfilePage ? (
                                        <Link to="/profile">
                                            <div className='flex ml-2'>
                                                <img src={personCircle} className='w-6 ml-2 mr-2' alt="Profile" />
                                                <img src={arrowRight} className='w-2 mr-2' alt="Navigate" />
                                            </div>
                                        </Link>
                                    ) : null}
                                </div></>) :
                                (<>
                                {user.userRole === Constants.USER_ROLES.EMPLOYEE && user.walletBalance >= 0 ? (
                                    <>
                                    <div className='basis-1/2 flex justify-start items-center'>
                                        {user.userRole === Constants.USER_ROLES.EMPLOYEE && user.walletBalance >= 0 ? (
                                            <div className={`text-center ${showCDWCashBalance ? 'opacity-100' : 'opacity-50'}`}>
                                                <div className='text-sm'>{Messages.PROFILE.CDW_CASH_BALANCE}</div>
                                                <div className='font-bold text-lg'>{Messages.CURRENCY.INR} {user.balance.cdw.amount}</div>
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className='w-[0.031rem] h-[2.188rem] m-auto bg-white'></div>
                                    <div className='basis-1/2 flex justify-end items-center'>
                                        <div className='text-center'>
                                            <div className='text-sm'>{elliptiscise(currentBalance.event.name) + " " + Messages.PROFILE._CASH_BALANCE}</div>
                                            <div className='font-bold text-lg'>{Messages.CURRENCY.INR} {user.balance.event.amount}</div>
                                        </div>
                                    </div>
                                    </>
                                    ) : null}
                                </>)}
                        </div>
                        {
                            user.userRole === Constants.USER_ROLES.EMPLOYEE &&
                                user.walletBalance && user.walletBalance > 0 &&
                                DateUtils.isGivenDateGreaterThanCurrent(Constants.SHOP.BALANCE_ALERT.EXPIRY_WARNING_DATE) ? (
                                <div className='bg-orange-500 text-center grow p-2 border-t text-sm'>
                                    {Messages.PROFILE.WALLET_EXPIRY_MESSAGE}
                                </div>
                            ) : null
                        }
                        {
                            isProfilePage ? (
                                <div className='flex w-full justify-content'>
                                    {
                                        user.userRole === Constants.USER_ROLES.EMPLOYEE ? (
                                            <div className='text-center grow p-2 border-t border-r' onClick={resetPassword}>
                                                {Messages.PROFILE.RESET_PASSWORD}
                                            </div>
                                        ) : null
                                    }

                                    <div className='text-center grow p-2 border-t' onClick={logout}>
                                        {Messages.PROFILE.LOGOUT}
                                    </div>
                                </div>

                            ) : null
                        }
                    </div>
                ) : null
            }
        </>
    )
}

ProfileCard.propTypes = {
    isProfilePage: PropTypes.bool,
    isEventTime: PropTypes.bool
};

export default ProfileCard;